'use strict';

import './HelpQuestion.less';

import React from 'react';
import PropTypes from 'prop-types';
import ReactCKImage from './ReactCKImage';

export default class HelpQuestion extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			showAnswer: false
		};

		this.toggleAnswer = this.toggleAnswer.bind(this);
	}

	toggleAnswer() {
		this.setState(prevState => ({
			showAnswer: !prevState.showAnswer
		}));
	}

	render() {
		return (
			<div className={`HelpQuestion ${!this.state.showAnswer ? 'collapsed' : ''} `}>
				<div className={'question'} onClick={this.toggleAnswer}>
					<ReactCKImage name={'back-purple'} />
					{this.props.question}
				</div>
				{this.state.showAnswer && <div className="answer">{this.props.answer}</div>}
			</div>
		);
	}
}

HelpQuestion.propTypes = {
	question: PropTypes.string.isRequired,
	answer: PropTypes.node.isRequired
};
